const AVAILABLE_CONTINENTS_EN = [
    {
        label: 'Africa',
        id: 1,
        airports: ['mxp']
    },
    {
        label: 'America',
        id: 2,
        airports: ['mxp']
    },
    {
        label: "Asia",
        id: 3,
        airports: ['mxp']
    },
    {
        label: "Europe",
        id: 4,
        airports: ['mxp', 'lin']
    },
]

export default AVAILABLE_CONTINENTS_EN;